const STALE_CHUNK_PATTERN =
  /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Loading chunk [\w-]+ failed|ChunkLoadError/i;
const RELOAD_STATE_KEY = 'staleChunkReloads';
const RELOAD_WINDOW_MS = 60000;
const MAX_RELOADS_IN_WINDOW = 2;
const RETRY_DELAY_MS = 5000;

export function isStaleChunkError(error: unknown): boolean {
  const err = error as { message?: unknown; name?: string } | null | undefined;
  const message = String(err?.message ?? error ?? '');
  return err?.name === 'ChunkLoadError' || STALE_CHUNK_PATTERN.test(message);
}

function recordReload(): boolean {
  let attempts: number[] = [];
  try {
    attempts = JSON.parse(sessionStorage.getItem(RELOAD_STATE_KEY) ?? '[]');
  } catch {
    // storage unavailable or corrupt — treat as no history
  }
  const now = Date.now();
  attempts = attempts.filter((t) => now - t < RELOAD_WINDOW_MS);
  const withinLimit = attempts.length < MAX_RELOADS_IN_WINDOW;
  attempts.push(now);
  try {
    sessionStorage.setItem(RELOAD_STATE_KEY, JSON.stringify(attempts));
  } catch {
    // ignore
  }
  return withinLimit;
}

/**
 * Silently reloads to pick up the current deploy after a lazy chunk 404s. No prompt is shown;
 * if reloads keep failing within the window, further reloads are delayed so a genuinely
 * missing chunk can't cause a tight reload loop.
 */
export function recoverFromStaleChunk(targetUrl?: string): void {
  const go = () => (targetUrl ? window.location.assign(targetUrl) : window.location.reload());
  if (recordReload()) {
    go();
  } else {
    setTimeout(go, RETRY_DELAY_MS);
  }
}
